/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */
import type {
  HttpResponse as AngularHttpResponse,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { ApplicationFormModel } from '../../model';

type HttpClientOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: any;
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};

@Injectable({ providedIn: 'root' })
export class JusticeService {
  constructor(private http: HttpClient) {}
  postApiJusticeSaveapplication<TData = void>(
    applicationFormModel: ApplicationFormModel,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  postApiJusticeSaveapplication<TData = void>(
    applicationFormModel: ApplicationFormModel,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  postApiJusticeSaveapplication<TData = void>(
    applicationFormModel: ApplicationFormModel,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  postApiJusticeSaveapplication<TData = void>(
    applicationFormModel: ApplicationFormModel,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.post<TData>(`/cvapwebform/api/Justice/saveapplication`, applicationFormModel, options);
  }
  getApiJusticeValidateVendorVendorNumberVendorPostalCode<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiJusticeValidateVendorVendorNumberVendorPostalCode<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiJusticeValidateVendorVendorNumberVendorPostalCode<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiJusticeValidateVendorVendorNumberVendorPostalCode<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(
      `/cvapwebform/api/Justice/validate_vendor/${vendorNumber}/${vendorPostalCode}`,
      options
    );
  }
  getApiJusticeValidateVendorAndCounsellorVendorNumberVendorPostalCodeCounsellorNumberCounsellorLastName<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    counsellorNumber: string,
    counsellorLastName: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiJusticeValidateVendorAndCounsellorVendorNumberVendorPostalCodeCounsellorNumberCounsellorLastName<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    counsellorNumber: string,
    counsellorLastName: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiJusticeValidateVendorAndCounsellorVendorNumberVendorPostalCodeCounsellorNumberCounsellorLastName<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    counsellorNumber: string,
    counsellorLastName: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiJusticeValidateVendorAndCounsellorVendorNumberVendorPostalCodeCounsellorNumberCounsellorLastName<TData = void>(
    vendorNumber: string,
    vendorPostalCode: string,
    counsellorNumber: string,
    counsellorLastName: string,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(
      `/cvapwebform/api/Justice/validate_vendor_and_counsellor/${vendorNumber}/${vendorPostalCode}/${counsellorNumber}/${counsellorLastName}`,
      options
    );
  }
}

export type PostApiJusticeSaveapplicationClientResult = NonNullable<void>;
export type GetApiJusticeValidateVendorVendorNumberVendorPostalCodeClientResult = NonNullable<void>;
export type GetApiJusticeValidateVendorAndCounsellorVendorNumberVendorPostalCodeCounsellorNumberCounsellorLastNameClientResult =
  NonNullable<void>;
